import moment = require("moment");

export default class HistoricalJobImport {

	constructor(
		public readonly importId: string,
		public readonly status: HistoricalJobImportStatus,
		public readonly createdAt: moment.Moment,
		public readonly totalRows: number | null,
		public readonly processedRows: number,
		public readonly skippedRows: number,
		public readonly failedRows: number,
		public readonly errorReportAvailable: boolean
	) {}

	static fromJson(json: HistoricalJobImportApiDto): HistoricalJobImport {
		return new HistoricalJobImport(
			json.importId,
			HistoricalJobImport.statusFromString(json.status),
			json.createdAt ? moment(json.createdAt) : null,
			json.totalRows === null || json.totalRows === undefined ? null : json.totalRows,
			json.processedRows || 0,
			json.skippedRows || 0,
			json.failedRows || 0,
			!!json.errorReportAvailable
		);
	}

	static statusFromString(status: string): HistoricalJobImportStatus {
		switch (status) {
			case HistoricalJobImportStatus.Created:
				return HistoricalJobImportStatus.Created;
			case HistoricalJobImportStatus.Processing:
				return HistoricalJobImportStatus.Processing;
			case HistoricalJobImportStatus.Completed:
				return HistoricalJobImportStatus.Completed;
			case HistoricalJobImportStatus.Failed:
				return HistoricalJobImportStatus.Failed;
			default:
				return status as HistoricalJobImportStatus;
		}
	}
}

export enum HistoricalJobImportStatus {
	Created = "CREATED",
	Processing = "PROCESSING",
	Completed = "COMPLETED",
	Failed = "FAILED"
}

interface HistoricalJobImportApiDto {
	importId: string;
	status: string;
	createdAt: string;
	totalRows?: number | null;
	processedRows?: number;
	skippedRows?: number;
	failedRows?: number;
	errorReportAvailable?: boolean;
}
